'use client'

import { IconAlertTriangle } from '@tabler/icons-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { ConfirmDialog } from '@/components/confirm-dialog'
import { useTranslation } from 'react-i18next'
import { handleServerError } from '@/utils/handle-server-error'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  onDeleted: () => void
  getDeleteName: () => string
  deleteRow: () => Promise<void>
  deleteTitle: string
}

export function DeleteDialog({
  open, onOpenChange, onDeleted, getDeleteName,
  deleteRow, deleteTitle
}: Props) {
  const i18n = useTranslation()

  const handleDelete = () => {
    deleteRow()
      .then(() => {
          onOpenChange(false)
          onDeleted()
      })
      .catch(e => {
        handleServerError(e)
      })
  }

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      handleConfirm={handleDelete}
      title={
        <span className='text-destructive'>
          <IconAlertTriangle
            className='mr-1 inline-block stroke-destructive'
            size={18}
          />{' '}
          {deleteTitle}
        </span>
      }
      desc={
        <div className='space-y-4'>
          <p className='mb-2 text-right'>
            {i18n.t('delete_confirm', { user: getDeleteName() })}
          </p>

          <Alert variant='destructive' className='text-right'>
            <AlertTitle>{i18n.t('warning')}</AlertTitle>
            <AlertDescription>
              {i18n.t('delete_warn')}
            </AlertDescription>
          </Alert>
        </div>
      }
      confirmText={i18n.t('delete')}
      cancelBtnText={i18n.t('cancel')}
      destructive
    />
  )
}
